import type { MouseEvent } from 'react';
import React, { Component, cloneElement, isValidElement } from 'react';
import { subscribe, unsubscribe } from '@alfa-bank/site-event-bus';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { IProps } from './models';

export class DataLayer extends Component<IProps> {
    componentDidMount() {
        const { blockSend, publisherEvent, sendOnRender } = this.props;

        if (sendOnRender && !blockSend) {
            this.handleSendEvent();
        }

        if (publisherEvent) {
            subscribe(publisherEvent, sendEvent);
        }
    }

    componentWillUnmount() {
        const { publisherEvent } = this.props;

        if (publisherEvent) {
            unsubscribe(publisherEvent, sendEvent);
        }
    }

    handleSendEvent = () => {
        const {
            children,
            className,
            data,
            onClick,
            publisherEvent,
            sendOnRender,
            tag,
            ...eventProps
        } = this.props;
        /* eslint-enable @typescript-eslint/no-unused-vars */

        sendEvent({ ...data, ...eventProps });
    };

    render() {
        const { blockSend, children, className, sendOnRender, tag } = this.props;

        // Если нужно посылать эвент на рендер или детей нет, то ничего рендерить не надо
        if (sendOnRender || !children) return null;

        /**
         * Если tag не прокинули, то проверяем что ребенок в children единственный и является валидным реакт компонентом, а не string и boolean.
         */
        if (tag === null && isValidElement(children)) {
            return cloneElement(children, {
                /**
                 * Декорируем onClick эвент в ребенке. Добавляем ему вызов аналитики
                 */
                onClick: (event: MouseEvent) => {
                    if (!blockSend) this.handleSendEvent();

                    if (children.props.onClick) {
                        children.props.onClick(event);
                    }
                },
            });
        }

        /**
         * Во всех остальных случаях рендерим, то что дали.
         */
        const Tag = (tag as keyof JSX.IntrinsicElements) || 'span';

        return (
            <Tag className={className} onClick={this.handleSendEvent}>
                {children}
            </Tag>
        );
    }
}
